import * as React from 'react';
import { LDFlagSet } from 'launchdarkly-js-sdk-common';
import { urlSvg } from '../../../../server/utils/urlConstants';
import { TYPES } from './types';
/* Style */
import '../../../styles/common.scss';
import './Case4CauseToast.scss';
// import SvgBlueUp from './blue-up';
import SvgGreyUp from './grey-up';
import SvgBlackUp from './black-up';

const imgUrlBlack = `${urlSvg}bottleBlack.svg`;
const imgUrlBlue = `${urlSvg}bottleBlue.svg`;
const imgUrlFourthBlue = `${urlSvg}bottleBlue4.svg`;
const imgUrlSixthBlue = `${urlSvg}bottleBlueMid.svg`;
const imgUrlTwelfthBlue = `${urlSvg}bottleBlueLast.svg`;
const imgUrlGrey = `${urlSvg}bottleGray.svg`;
const imgUrlSixthGrey = `${urlSvg}bottleGrayMid.svg`;
const imgUrlTwelfthGrey = `${urlSvg}bottleGrayLast.svg`;
const imgUrlSixthBlack = `${urlSvg}bottleBlackMid.svg`;
const imgUrlTwelfthBlack = `${urlSvg}bottleBlackLast.svg`;
const imgUrlFourthGrey = `${urlSvg}bottleGray4.svg`;
const imgUrlFourthBlack = `${urlSvg}bottleBlack4.svg`;
// const boxCountDark = `${urlSvg}boxCountDark.svg`;

const emptyArray = new Array(12);

export function getBottles(cartQty: number) {
  const qualifiedCartTotalModulo = cartQty % 12;
  const hasQualifiedCartItems = cartQty > 0;
  emptyArray.fill(imgUrlGrey);

  return emptyArray.map((img, index) => {
    const bottleIndex = index + 1;
    const isFirst6Bottles = bottleIndex <= 6;
    const isLast6Bottles = bottleIndex > 6;
    const isDiscount20 = qualifiedCartTotalModulo === 0 && cartQty > 0;
    const isDiscount10 = qualifiedCartTotalModulo >= 6;
    const isDiscount5 = qualifiedCartTotalModulo >= 4;
    const isBottleSelected = bottleIndex <= qualifiedCartTotalModulo;
    const isBlackBottle =
      (isLast6Bottles && isBottleSelected && bottleIndex < 12) ||
      (isFirst6Bottles &&
        qualifiedCartTotalModulo < 6 &&
        isBottleSelected &&
        !isDiscount5) ||
      (bottleIndex === 5 &&
        isDiscount5 &&
        isBottleSelected &&
        !isDiscount20 &&
        !isDiscount10);
    const isBlueBottle =
      isDiscount20 ||
      (isDiscount10 && isBottleSelected) ||
      (isDiscount5 && isBottleSelected);
    const isMidBottle = bottleIndex === 6 && !isDiscount10;
    const isLastBottle = bottleIndex === 12 && !isDiscount20;
    const isFourthBottle = bottleIndex === 4;
    const isMidBottleSelected =
      bottleIndex === 6 && (isDiscount10 || isDiscount20);
    const isLastBottleSelected = bottleIndex === 12 && isDiscount20;

    switch (true) {
      case isMidBottleSelected:
        return imgUrlSixthBlue;
      case isLastBottleSelected:
        return imgUrlTwelfthBlue;
      case !hasQualifiedCartItems && isFourthBottle:
        return imgUrlFourthBlack;
      case !hasQualifiedCartItems && isMidBottle:
        return imgUrlSixthBlack;
      case !hasQualifiedCartItems && isLastBottle:
        return imgUrlTwelfthBlack;
      case isFourthBottle:
        if (isDiscount5 || isDiscount10 || isDiscount20) {
          return imgUrlFourthBlue;
        }
        return imgUrlFourthGrey;
      case isMidBottle:
        return imgUrlSixthGrey;
      case isLastBottle:
        return imgUrlTwelfthGrey;
      case isBlackBottle:
        return imgUrlBlack;
      case isBlueBottle:
        return imgUrlBlue;
      case hasQualifiedCartItems:
      default:
        return imgUrlGrey;
    }
  });
}
export function getPercentageColor(imgPath: string) {
  switch (imgPath) {
    case imgUrlSixthBlack:
      return 'percent-black';
    case imgUrlTwelfthBlack:
      return 'percent-black';
    case imgUrlSixthGrey:
      return 'percent-black';
    case imgUrlTwelfthGrey:
      return 'percent-black';
    case imgUrlFourthBlue:
      return 'percent-blue';
    case imgUrlSixthBlue:
      return 'percent-blue';
    case imgUrlTwelfthBlue:
      return 'percent-blue';
    case imgUrlFourthBlack:
      return 'percent-black';
    case imgUrlFourthGrey:
      return 'percent-black';
    default:
      return 'default-percent';
  }
}

export function getUpArrow(imgPath: string) {
  switch (imgPath) {
    case imgUrlSixthBlack:
      return <SvgBlackUp />;
    case imgUrlTwelfthBlack:
      return <SvgBlackUp />;
    case imgUrlSixthGrey:
      return <SvgGreyUp />;
    case imgUrlTwelfthGrey:
      return <SvgGreyUp />;
    // case imgUrlBlueCheck:
    //   return <SvgBlueUp />;
    default:
      return <SvgGreyUp />;
  }
}

export function getBoxCountTotal(cartQty: number) {
  const boxCountTotal = cartQty / 12;
  const isWholeNumber = Number.isInteger(boxCountTotal);
  return isWholeNumber ? boxCountTotal : boxCountTotal.toFixed(1);
}

export function getBlackFriday(flags?: LDFlagSet) {
  return flags && flags.blackFriday2020Sale;
}

type GetCause4CauseToastPrimitivesProps = {
  c4cCartTotal: number;
  qtyInCart: number;
  isUserPC: boolean;
  componentType: string;
  enrollingAsPC: boolean;
  isDiscount20: boolean;
};

export function getCause4CauseToastPrimitives({
  c4cCartTotal,
  qtyInCart,
  isUserPC,
  componentType,
  enrollingAsPC,
  isDiscount20,
}: GetCause4CauseToastPrimitivesProps) {
  const isPC = isUserPC || enrollingAsPC;
  const hasMaxDiscount = c4cCartTotal >= 12;
  const isUpsellHeader = componentType === TYPES.UPSELL_HEADER;
  const showSavingsNonPC =
    (isDiscount20 || hasMaxDiscount) && qtyInCart === 0 && !isPC;
  const showSavingsPC =
    (isDiscount20 || qtyInCart >= 4 || hasMaxDiscount) && isPC;
  const PCDefault = !isDiscount20 && isPC;
  const nonPCDefault = !isDiscount20 && !isPC;
  return {
    isPC,
    isUpsellHeader,
    showSavingsPC,
    showSavingsNonPC,
    PCDefault,
    nonPCDefault,
    hasMaxDiscount,
  };
}
